var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "goods-card", on: { click: _vm.handleGoodsCard } },
    [
      _c("div", { staticClass: "goods-card-main" }, [
        _c("img", {
          directives: [
            {
              name: "lazy",
              rawName: "v-lazy",
              value: _vm.item.pict_url,
              expression: "item.pict_url",
            },
          ],
          staticClass: "goods-pic",
          attrs: { src: _vm.item.pict_url, alt: "" },
        }),
        _c("div", { staticClass: "goods-info" }, [
          _c(
            "div",
            {
              staticClass: "goods-title",
              class: [
                { "van-multi-ellipsis--l2": !_vm.isGYApp },
                { "van-ellipsis": _vm.isGYApp },
              ],
            },
            [
              _c("img", {
                staticClass: "platform-icon",
                attrs: {
                  src: _vm._f("classTypeImg")(_vm.item.classtype),
                  alt: "",
                },
              }),
              _vm._v(_vm._s(_vm.item.title)),
            ]
          ),
          _c("div", [
            _vm.item.couponmoney
              ? _c("div", { staticClass: "coupon" }, [
                  _vm._v(_vm._s(_vm.item.couponmoney) + "元券"),
                ])
              : _vm._e(),
            _vm.isGYApp
              ? _c("div", { staticClass: "commission-wrap" }, [
                  _c("div", { staticClass: "commission-pre" }, [
                    _vm._v(
                      "返" +
                        _vm._s(_vm.item.gy_commission) +
                        "元+补" +
                        _vm._s(_vm.item.gy_subsidy_info.self_money) +
                        "元"
                    ),
                  ]),
                  _c("div", { staticClass: "commission" }, [
                    _vm._v("赚" + _vm._s(_vm.totalCommission()) + "元"),
                  ]),
                ])
              : _vm._e(),
            _c("div", { staticClass: "price-sale-wrap" }, [
              _c("div", { staticClass: "price-wrap" }, [
                _c("div", { staticClass: "now-price" }, [
                  _vm._v("￥"),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm._f("pricePartFilter")(_vm.item.itemendprice))
                    ),
                  ]),
                  _vm._v(
                    _vm._s(_vm._f("pricePartFilter")(_vm.item.itemendprice, 2))
                  ),
                ]),
                _c("div", { staticClass: "orig-price" }, [
                  _vm._v("￥" + _vm._s(_vm.item.zk_final_price)),
                ]),
              ]),
              _vm.item.volume
                ? _c("div", { staticClass: "sale" }, [
                    _vm._v(
                      _vm._s(_vm._f("saleFilter")(_vm.item.volume)) + "人购买"
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
      ]),
      _vm.isGYApp
        ? _c("div", { staticClass: "btn-wrap" }, [
            _c(
              "div",
              {
                staticClass: "btn share-btn",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleShareLink.apply(null, arguments)
                  },
                },
              },
              [_vm._v("分享推广链接")]
            ),
            _c(
              "div",
              {
                staticClass: "btn buy-btn",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleBuy.apply(null, arguments)
                  },
                },
              },
              [_vm._v("立即购买")]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }